import TeacherEmployee from '../../../views/Personnel/Report/TeacherEmployee.report.view';

export default TeacherEmployee;
